import { useEffect, useState } from 'react';
import { useGetActivities } from 'api/activities';
import { Activity } from 'api/activities/activities.types';
import { AutocompletePaginationAsync } from 'components/Inputs';
import { ControllerRenderProps } from 'react-hook-form';
import { createHandleOnBlur, handleChange } from 'utils/form.utils';

export type ServiceOption = {
  id: number;
  name: string;
};

type Props = {
  field: Pick<ControllerRenderProps, 'value' | 'onChange' | 'onBlur' | 'ref'>;
  error?: boolean;
};

export const ServiceSelect = ({ field, error }: Props) => {
  const [options, setOptions] = useState<Activity[]>([]);
  const [params, setParams] = useState({
    filterText: '',
    pageNumber: 1,
    resultSize: 25,
  });

  const { getActivities, loading, data: activitiesData } = useGetActivities();

  useEffect(() => {
    getActivities(params);
  }, [getActivities, params]);

  useEffect(() => {
    if (activitiesData?.length) {
      setOptions((prev) => [
        ...prev,
        ...activitiesData.filter((activity) => activity.enabled),
      ]);
    }
  }, [activitiesData]);

  return (
    <AutocompletePaginationAsync
      value={field.value ?? null}
      options={options}
      loading={loading}
      error={error}
      padding='dense'
      width={280}
      getOptionLabel={(option) => (option as Activity).code}
      isOptionEqualToValue={(option, value) =>
        (option as Activity).id === (value as Activity).id
      }
      onChange={(_, value) => field.onChange(value ?? null)}
      onBlur={createHandleOnBlur(setOptions, setParams, field.onBlur)}
      handleSearchChange={handleChange(setOptions, setParams)}
      onScrollBottom={() =>
        setParams((prev) => ({ ...prev, pageNumber: prev.pageNumber + 1 }))
      }
    />
  );
};
